<template>
  <div id="UD" class="row">
    <div class="col-sm-6">
      <b-form @submit.prevent="onSubmit" @reset="onReset">
        <b-form-group
          id="input-group-1"
          label="ID de UD"
          description="En caso que tenga id"
          label-for="input-1"
        >
          <b-form-input
            id="input-1"
            v-model="form.catastroUD_unico"
            type="number"
            placeholder="identificador de ud"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="input-group-2"
          label="Colector asociado a UD"
          label-for="input-2"
        >
          <b-form-input
            id="input-2"
            type="number"
            v-model="form.catastroUD_identifica"
            required
            placeholder="Ingrese id de colector"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="input-sc"
          label="Subcuenca que se encuentra la UD"
          label-for="sc"
        >
          <b-form-input
            id="sc"
            v-model="form.catastroUD_subcuenca"
            required
            type="number"
            placeholder="Ingrese subcuenca"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="input-dir"
          label="Direccion de ud"
          description="en caso de no contar con identificador de UD"
          label-for="sc"
        >
          <b-form-input
            id="sc"
            v-model="form.catastroUD_direccion"
            :required="form.catastroUD_unico.length<=0"
            placeholder="Ingrese direccion"
          ></b-form-input>
        </b-form-group>
        <b-form-group label="Se encontro falla">
          <b-form-checkbox
            id="checkbox-1"
            v-model="form.catastroUD_falla"
            name="checkbox-1"
          >
            Falla en UD
          </b-form-checkbox>
        </b-form-group>
        <b-form-group label="Descripcion">
        <b-form-textarea
          id="textarea"
          v-model="form.catastroUD_descripcion"
          placeholder="descripcion si es necesaria"
          rows="3"
          :required="form.catastroUD_falla"
          max-rows="6"
        ></b-form-textarea>
        </b-form-group>
        <b-form-group
          label="Imagenes"
          label-for="file-small"
          label-cols-sm="2"
          label-size="sm"
        >
          <b-form-file
            accept=".JPG,.jpg,.png,.PNG,.jpeg,.JPEG"
            @change="uploadFieldChange"
            multiple
            placeholder="Agrege una imagen"
            drop-placeholder="Drop file here..."
            ref="file-input"
          >
          </b-form-file>
          <b-list-group>
            <b-list-group-item v-for="(data, index) in Images" :key="index"
              >{{ data.name
              }}<b-button
                @click="deleteImage(index)"
                class="float-right"
                variant="danger"
                size="sm"
                ><span class="ti-trash"></span></b-button
            ></b-list-group-item>
          </b-list-group>
        </b-form-group>


        <b-button type="submit" variant="primary">Enviar</b-button>
        <b-button class="float-right" type="reset" variant="danger"
          >Limpiar</b-button
        >
      </b-form>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-console */

import Http from "../Http";
import NotificationTemplate from "./Notifications/NotificationTemplate";
export default {
  name: "CatastroUD",
  data: () => ({
    form: {
      catastroUD_unico: "",
      catastroUD_identifica: "",
      catastroUD_subcuenca: "",
      catastroUD_direccion: "",
      catastroUD_falla: false,
        catastroUD_descripcion :""
    },
    Images: []
  }),
  methods: {
    uploadFieldChange(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (files.length > 0) {
        for (let i = files.length - 1; i >= 0; i--) {
          let allowedExtensions = /(.jpg|.JPG|.png|.PNG|.jpeg|.JPEG)$/i;
          if (!allowedExtensions.exec(files[i].name)) {
            alert("extencion no permitida");
          } else {
            this.Images.push(files[i]);
          }
        }
      }
    },
    onSubmit() {
      if (this.Images.length < 1) {
        alert("Minimo 1 imagenes");
        return;
      }
      let config = {
        headers: { "Content-Type": "multipart/form-data" }
      };
      let Formdata = new FormData();
      if(this.form.catastroUD_unico==null||this.form.catastroUD_unico.length===0){
          this.form.catastroUD_unico=0;
      }
      Formdata.append("body", JSON.stringify(this.form));
      this.Images.forEach(I => {
        Formdata.append(I.name, I);
      });
      Http.Http()
        .post("Catastroud", Formdata, config)
        .then(() => {
          this.$notify({
            component: NotificationTemplate,
            icon: "ti-save",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "success"
          });
          this.onReset();
        });
    },
    deleteImage(index) {
      if (confirm("esta seguro que quiere eliminar la imagen?")) {
        this.Images.splice(index, 1);
      }
    },
    formatNames(files) {
      if (files.length === 1) {
        return files[0].name;
      } else {
        return `${files.length} files selected`;
      }
    },
    onReset() {
      this.form = {
        catastroUD_unico: "",
        catastroUD_identifica: "",
        catastroUD_subcuenca: "",
        catastroUD_direccion: "",
          catastroUD_falla: false,
          catastroUD_descripcion :""
      };
      this.Images = [];
      this.$refs["file-input"].reset();
    }
  }
};
</script>

<style scoped></style>
